module.exports = __webpack_public_path__ + "img/bracket-5.13c583cd.svg";